import React from 'react';
import { type ButtonHTMLAttributes, type ReactNode } from 'react';
import BiaSpinner from '../BiaSpinner/BiaSpinner';
import './BiaButton.css';

interface BiaButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  loading?: boolean;
  loadingText?: string;
}

const BiaButton: React.FC<BiaButtonProps> = ({
  children,
  onClick,
  className = '',
  disabled = false,
  style,
  size = 'md',
  color = 'white',
  loading = false,
  loadingText,
  ...rest
}) => {
  const isDisabled = disabled || loading;
  return (
  <button
    className={`bia-button color-${color} ${size} ${className} ${
      isDisabled ? 'disabled' : ''
    }`}
    style={style}
    onClick={loading ? undefined : onClick}
    disabled={isDisabled}
    aria-busy={loading || undefined}
    {...rest}
  >
    {loading && <BiaSpinner size="sm" className="mr-1" style={{ color: 'inherit' }} />}
    {loading && loadingText ? loadingText : children}
  </button>
  );
};

export default BiaButton;
